import MandateORM from "@/store/orm-axios/models/Mandate";
import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";
import MeetingResolutionORM from "@/store/orm-axios/models/MeetingResolution";

export default {
  computed: {
    meetingDetails() {
      return this.$store.state.meetingDetails;
    },
  },
  methods: {
    getCurrentResolution(meeting) {
      const meetingResolutions = MeetingResolutionORM.query()
        .where("meeting_id", meeting.id)
        .with("parent_resolution")
        .withAllRecursive(2)
        .get();

      // Get resolution with status started
      let currentResolution = this.$_.find(meetingResolutions, resolution => {
        return resolution.status == this.meetingResolutionStatuses.started;
      });
      // If resolution with status started doesn't exists, show the current_resolution_id
      if (!currentResolution) {
        return this.$_.find(meetingResolutions, resolution => {
          return resolution.id == meeting.current_resolution_id;
        });
      } else {
        return currentResolution;
      }
    },
    async setMeetingDetails(meeting) {
      this.$store.commit("setMeetingDetailesMeetingId", meeting.id);
      this.$store.commit("setMeetingDetailesBuildingId", meeting.building_id);

      var BuildingOwnersData = this.getBuildingOwnersData(meeting.id);
      this.$store.commit("setMeetingDetailesBuildingOwnersData", BuildingOwnersData);
    },
    getBuildingOwnersData(meetingId) {
      var mandates = MandateORM.query()
        .where("meeting_id", meetingId)
        .with("building_owner", query => {
          query.with("building_owner_building_lots", q2 => {
            q2.with("building_lot");
            q2.with("building_owner_voting_rights", q3 => {
              q3.with("votingCategory");
            });
          });
        })
        .get();

      var votingCategories = VotingCategoryORM.all();
      var votingRightsByVotingCategory = {};
      this.$_.each(votingCategories, vt => {
        votingRightsByVotingCategory[vt.slug] = {
          slug: vt.slug,
          is_charge_generale: vt.is_charge_generale,
          id: vt.id,
          tantiemes: 0,
        };
      });

      var buildingOwners = [];
      this.$_.each(mandates, m => {
        var boDetails = this.getBuildingOwnerDetails(
          m.building_owner,
          m.id,
          votingRightsByVotingCategory
        );
        buildingOwners.push(boDetails);
      });

      return buildingOwners;
    },
    getBuildingOwnerDetails(bo, mandateId, votingCategories) {
      var votingRightsByVotingCategory = JSON.parse(JSON.stringify(votingCategories));

      let name = "";
      if (bo.lastname) {
        name = bo.lastname.toUpperCase();
      }
      if (bo.firstname) {
        name = bo.firstname.toUpperCase();
      }
      if (bo.lastname && bo.firstname) {
        name = bo.lastname.toUpperCase() + " " + bo.firstname.toUpperCase();
      }

      let buildingLots = "";
      this.$_.each(bo.building_owner_building_lots, bobl => {
        if (
          bo.building_owner_building_lots.length > 0 &&
          bobl != this.$_.last(bo.building_owner_building_lots)
        ) {
          buildingLots += bobl.building_lot.name + ", ";
        } else {
          buildingLots += bobl.building_lot.name;
        }

        this.$_.each(bobl.building_owner_voting_rights, votingRight => {
          votingRightsByVotingCategory[votingRight.votingCategory.slug].name =
            votingRight.votingCategory.name;
          votingRightsByVotingCategory[votingRight.votingCategory.slug].is_charge_generale =
            votingRight.votingCategory.is_charge_generale;
          votingRightsByVotingCategory[votingRight.votingCategory.slug].tantiemes +=
            votingRight.parts;
        });
      });

      return {
        name,
        building_lots: buildingLots,
        mandate_id: mandateId,
        id: bo.id,
        votingRightsByVotingCategory,
      };
    },
    findBuildingOwner(buildingOwnerId) {
      return this.meetingDetails.BuildingOwnersData.find(bo => bo.id == buildingOwnerId);
    },
  },
};
